@if (headerOptions.showToggleButton) {
<div
  class="relative rounded-[10px] transition-colors duration-200 inline-flex"
  [class.bg-[#F5F5F5]]="!bgColor"
  [class.dark:bg-surface-3]="!bgColor"
  [style.backgroundColor]="bgColor"
  [ngClass]="{
    'py-[6px] px-2': headerOptions.showlabels && headerOptions.size !== 'sm',
    'py-1 px-1': !headerOptions.showlabels && headerOptions.size !== 'sm',
    'py-1 px-1.5': headerOptions.size === 'sm' && headerOptions.showlabels,
    'py-0.5 px-1': headerOptions.size === 'sm' && !headerOptions.showlabels
  }"
>
  <div
    [ngClass]="{
      'py-[4px] gap-1': headerOptions.showlabels && headerOptions.size !== 'sm',
      'py-0.5 gap-0.5': (!headerOptions.showlabels && headerOptions.size !== 'sm') || headerOptions.size === 'sm'
    }"
    class="grid relative w-full items-center h-full gap-0"
    [style.grid-template-columns]="
      'repeat(' + (headerOptions.toggleOptions?.length || 2) + ', 1fr)'
    "
  >
    <!-- Sliding Background -->
    <span
      class="cursor-pointer absolute rounded-[8px] transition-transform duration-700 ease-out shadow-sm z-0"
      [style.backgroundColor]="headerOptions.activeBgColor || (isDark() ? '#151517' : '#FFFFFF')"
      [ngClass]="{
        'top-[2px] bottom-[2px]': headerOptions.showlabels && headerOptions.size !== 'sm',
        'inset-0': !headerOptions.showlabels && headerOptions.size !== 'sm',
        'top-0.5 bottom-0.5': headerOptions.size === 'sm'
      }"
      [style.width.%]="
        headerOptions.toggleOptions && headerOptions.toggleOptions.length > 0
          ? 100 / headerOptions.toggleOptions.length
          : 50
      "
      [style.transform]="'translateX(' + getActiveIndex() * 100 + '%)'"
    ></span>

    <!-- Options -->
    @if (headerOptions && headerOptions.toggleOptions &&
    headerOptions.toggleOptions.length > 0) { @for(option of
    headerOptions.toggleOptions; track option?.isTable ?? false; let idx =
    $index) {
    <div class="flex justify-center items-center relative z-10 w-full h-full px-1">
      @if (option.tooltip && option.tooltip.trim() !== '') {
        <app-tooltip
          [position]="'top'"
          [width]="'auto'"
          [className]="'whitespace-nowrap'"
          [content]="option.tooltip"
          [maxWidth]="'400px'"
          [useFixedStrategy]="true"
          [disabled]="true"
        >
          <span
            class="cursor-pointer relative flex items-center justify-center transition-colors gap-2 duration-200 w-full"
            [ngClass]="{
              'px-4 py-[4px]': headerOptions.showlabels && headerOptions.size !== 'sm',
              'px-1.5 py-1': !headerOptions.showlabels && headerOptions.size !== 'sm',
              'px-2 py-1': headerOptions.size === 'sm' && headerOptions.showlabels,
              'px-1 py-0.5': headerOptions.size === 'sm' && !headerOptions.showlabels
            }"
            (click)="toggleView(option.isTable ?? true, option)"
          >
            @if (headerOptions.showlabels) { @if (headerOptions.showIcon &&
            option.iconName) {
            <app-icon
              [name]="option.iconName"
              [size]="headerOptions.size === 'sm' ? 14 : 16"
              [style.color]="headerOptions.activeTextColor || headerOptions.inactiveTextColor ? (getActiveIndex() === idx ? getActiveTextColor() : getInactiveTextColor()) : null"
              [ngClass]="{
                'text-[#AD46FF] dark:text-purple-500': getActiveIndex() === idx && !headerOptions.activeTextColor,
                'text-[#7D7D93] dark:text-ink-muted': getActiveIndex() !== idx && !headerOptions.inactiveTextColor
              }"
            ></app-icon>
            }

            <span
              [ngClass]="{
                'text-xs': headerOptions.size === 'sm',
                'text-sm': headerOptions.size !== 'sm',
                'text-[#AD46FF] dark:text-purple-500': getActiveIndex() === idx && !headerOptions.activeTextColor,
                'text-[#7D7D93] dark:text-ink-muted': getActiveIndex() !== idx && !headerOptions.inactiveTextColor
              }"
              [style.color]="headerOptions.activeTextColor || headerOptions.inactiveTextColor ? (getActiveIndex() === idx ? getActiveTextColor() : getInactiveTextColor()) : null"
              class="font-medium whitespace-nowrap text-center w-full"
            >
              {{ option.label }}
            </span>
            } @if (!headerOptions.showlabels) { @if (headerOptions.showIcon &&
            option.iconName) {
            <app-icon
              [name]="option.iconName"
              [size]="headerOptions.size === 'sm' ? 14 : 16"
              [style.color]="headerOptions.activeTextColor || headerOptions.inactiveTextColor ? (getActiveIndex() === idx ? getActiveTextColor() : getInactiveTextColor()) : null"
              [ngClass]="{
                'text-[#AD46FF] dark:text-purple-500': getActiveIndex() === idx && !headerOptions.activeTextColor,
                'text-[#7D7D93] dark:text-ink-muted': getActiveIndex() !== idx && !headerOptions.inactiveTextColor
              }"
            ></app-icon>
            } }
          </span>
        </app-tooltip>
      } @else {
        <span
          class="cursor-pointer relative flex items-center justify-center transition-colors gap-2 duration-200 w-full"
          [ngClass]="{
            'px-4 py-[4px]': headerOptions.showlabels && headerOptions.size !== 'sm',
            'px-1.5 py-1': !headerOptions.showlabels && headerOptions.size !== 'sm',
            'px-2 py-1': headerOptions.size === 'sm' && headerOptions.showlabels,
            'px-1 py-0.5': headerOptions.size === 'sm' && !headerOptions.showlabels
          }"
          (click)="toggleView(option.isTable ?? true, option)"
        >
          @if (headerOptions.showlabels) { @if (headerOptions.showIcon &&
          option.iconName) {
          <app-icon
            [name]="option.iconName"
            [size]="headerOptions.size === 'sm' ? 14 : 16"
            [style.color]="headerOptions.activeTextColor || headerOptions.inactiveTextColor ? (getActiveIndex() === idx ? getActiveTextColor() : getInactiveTextColor()) : null"
            [ngClass]="{
              'text-[#AD46FF] dark:text-purple-500': getActiveIndex() === idx && !headerOptions.activeTextColor,
              'text-[#7D7D93] dark:text-ink-muted': getActiveIndex() !== idx && !headerOptions.inactiveTextColor
            }"
          ></app-icon>
          }

          <span
            [ngClass]="{
              'text-xs': headerOptions.size === 'sm',
              'text-sm': headerOptions.size !== 'sm',
              'text-[#AD46FF] dark:text-purple-500': getActiveIndex() === idx && !headerOptions.activeTextColor,
              'text-[#7D7D93] dark:text-ink-muted': getActiveIndex() !== idx && !headerOptions.inactiveTextColor
            }"
            [style.color]="headerOptions.activeTextColor || headerOptions.inactiveTextColor ? (getActiveIndex() === idx ? getActiveTextColor() : getInactiveTextColor()) : null"
            class="font-medium whitespace-nowrap text-center w-full"
          >
            {{ option.label }}
          </span>
          } @if (!headerOptions.showlabels) { @if (headerOptions.showIcon &&
          option.iconName) {
          <app-icon
            [name]="option.iconName"
            [size]="headerOptions.size === 'sm' ? 14 : 16"
            [style.color]="headerOptions.activeTextColor || headerOptions.inactiveTextColor ? (getActiveIndex() === idx ? getActiveTextColor() : getInactiveTextColor()) : null"
            [ngClass]="{
              'text-[#AD46FF] dark:text-purple-500': getActiveIndex() === idx && !headerOptions.activeTextColor,
              'text-[#7D7D93] dark:text-ink-muted': getActiveIndex() !== idx && !headerOptions.inactiveTextColor
            }"
          ></app-icon>
          } }
        </span>
      }
    </div>
    } }
  </div>
</div>
}
